export default __webpack_public_path__ + "static/media/ReFPredictorLeague-PrivacyPolicy.c81f0c1b.pdf";